export default {
    install(Vue) {
        String.prototype.numberFormat = function() {
            var find = /(\d+)(\d{3})/
            var num = this.replace(/[^0-9]/g, "")

            num = num.replace(/,/g, "")

            while (find.test(num)) {
                num = num.replace(find, '$1' + ',' + '$2')
            }

            return num
        }

        String.prototype.stripTag = function() {
            var text = this.replace(/<br>/ig, "\n")
            text = text.replace(/<br\/>/ig, "\n")
            text = text.replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/ig, "")

            return text
        }

        String.prototype.getQuery = function(key) {
            var _parammap = {}

            this.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function() {
                function decode(s) {
                    return decodeURIComponent(s.split("+").join(" "))
                }

                _parammap[decode(arguments[1])] = decode(arguments[2])
            });

            return _parammap[key]
        }

        String.prototype.patternCheck = function(flag) {
            var pattern = ''

            switch (flag) {
                //영문만 유효성 검사
                case 'eng':
                    pattern = /^[a-z|A-Z]+$/
                    break
                //영문,숫자 유효성 검사
                case 'engnum':
                    pattern = /^[(a-z|A-Z)0-9]+$/
                    break
                //영문,숫자 혼합사용 유효성 검사
                case 'engnum+':
                    pattern = /^([0-9]+[a-z|A-Z]+)|([a-z|A-Z]+[0-9]+)$/
                    break
                //아이디 영문,숫자,underbar(_) 사용 유효성 검사
                case 'id':
                    pattern = /^[(a-z|A-Z)0-9]+[_]*[(a-z|A-Z)0-9]+$/
                    break
                //정수 유효성 검사
                case 'num':
                    pattern = /^[0-9]+$/
                    break
                //이메일 유효성 검사
                case 'email':
                    pattern = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/
                    break
            }

            return pattern.test(this.toString())
        }

        String.prototype.nl2br = function() {
            if (this.trim().length > 0 || this.trim()) {
                return this.trim().replace(/\n/g, "<br>")
            } else {
                return ""
            }
        }

        String.prototype.isEmpty = function(str) {
            if (this.length === 0 || this === null || this === undefined) {
                if (str != '' && str !== undefined) {
                    return str
                } else {
                    return ''
                }
            } else {
                return this
            }
        }

        String.prototype.thumbnail = function() {
            var path = this.split('/')
            return path[0] + '/thumb/' + path[1]
        }

        String.prototype.getAge = function() {
            let sp = this.split('-')
            let date = new Date(sp[0], sp[1], sp[2], 0, 0, 0)
            let now = new Date()
            let age = now.getFullYear() - date.getFullYear()

            if (date.getMonth() < now.getMonth()) {
                age--
            } else if (date.getDate() < now.getDate()) {
                age--
            }

            return age
        }

        //=========================================================================
        //  함수 명 : mask
        //  함수 설명 : 각종 마스킹 처리
        //=========================================================================
        String.prototype.phoneNumber = function() {
            let str = ''
            const len = this.length

            if (len == 9) {
                str = this.substr(0, 2) + '-' + this.substr(2, 3) + '-' + this.substr(5, 4)
            } else if (len == 10) {
                str = this.substr(0, 3) + '-' + this.substr(2, 3) + '-' + this.substr(5, 4)
            } else if (len == 11) {
                str = this.substr(0, 3) + '-' + this.substr(2, 4) + '-' + this.substr(5, 4)
            }

            return str
        }

        //=========================================================================
        //  함수 명 : mask
        //  함수 설명 : 각종 마스킹 처리
        //=========================================================================
        String.prototype.mask = function(type='')  {
            let str = '', email = '', addr = ''

            // 설정 값을 받아 그에 맞게 마스킹 처리 한다.
            if (type != '') {
                if (this != '') {
                    if (type == 'id') {
                        str = this.substr(0, 5) + '*'.repeat(strlen(this) - 5)
                    } else if (type == 'email') {
                        email = this.split('@')

                        if (email[0].length > 5) {
                            str = email[0].substr(0, 5) + '*'.repeat(strlen(email[0]) - 5) + '@' + email[1]
                        } else if (email[0].length < 3) {
                            str = email[0] + '@' + email[1]
                        } else {
                            str = email[0].substr(0, 3) + '*'.repeat(strlen(email[0]) - 3) + '@' + email[1]
                        }
                    } else if (type == 'phone') {
                        str = this.substr(0, 4) + '-****-' + this.substr(-4)
                    } else if (type == 'addr') {
                        addr = this.split(' ')

                        if (typeof addr == 'array') {
                            for (let i = 0; i < addr.length; i++) {
                                if (i > 1) {
                                    str += '*'.repeat(addr[i].length) + ' '
                                } else {
                                    str += addr[i] + ' '
                                }
                            }
                        }
                    }
                }
            } else {
                // 사용자 명 마스킹
                str = this.substr(0, 1) + '*' + this.substr(2)
            }

            return str
        }

        Date.prototype.getDateFormat = function(format) {
            let year = parseInt(this.getYear()) - 100
            let month = this.getMonth() + 1
            let day = this.getDate()
            let dYear = this.getFullYear()
            let dMonth = month
            let dDay = day

            if (month.toString().length == 1) dMonth = "0" + month
            if (day.toString().length == 1) dDay = "0" + day

            format = format.replace("Y", dYear)
            format = format.replace("m", dMonth)
            format = format.replace("d", dDay)
            format = format.replace("y", year)
            format = format.replace("n", month)
            format = format.replace("j", day)

            return format
        }

        Date.prototype.getTimeFormat = function(format) {
            let hours = this.getHours()
            let min = this.getMinutes()
            let sec = this.getSeconds()
            let dHours = hours
            let dMin = min
            let dSec = sec

            if (hours.toString().length == 1) dHours = "0" + hours
            if (min.toString().length == 1) dMin = "0" + min
            if (sec.toString().length == 1) dSec = "0" + sec

            format = format.replace("H", dHours)
            format = format.replace("i", dMin)
            format = format.replace("s", dSec)

            return format
        }

        // 해당 날짜를 비교 하여 date값 과의 날짜 차이를 반환 한다.
        // 해당 date 인자는 date object로 받아야 한다
        Date.prototype.dateDiff = function(date) {
            const now = new Date(this.getFullYear(), this.getMonth(), this.getDate())
            const selfTime = now.getTime()
            const getTime = date.getTime()

            return parseInt((getTime - selfTime) / 86400 / 1000)
        }

        Array.prototype.inArray = function(find) {
            return this.indexOf(find) > -1 ? true : false
        }

        Array.prototype.indexRemove = function(find) {
            return this.splice(this.indexOf(find), 1)
        }

        Element.prototype.$formData = function() {
            let len = this.length;
            let data = new FormData()

            for (var i = 0; i < len; i++) {
                if (this[i].name) {
                    if (this[i].type == 'file') {
                        for (var j = 0; j < this[i].files.length; j++) {
                            data.append(this[i].name, this[i].files[j])
                        }
                    } else if (this[i].type == 'checkbox' || this[i].type == 'radio') {
                        if (this[i].checked) {
                            data.append(this[i].name, this[i].value)
                        }
                    } else {
                        data.append(this[i].name, this[i].value)
                    }
                }
            }

            return data
        }

        NodeList.prototype.$index = function(trg) {
            for (var i = 0; i < this.length; i++) {
                if (this[i] === trg) {
                    return i
                }
            }

            return -1
        }

        Vue.prototype.$loginCheck = function() {
            return this.$store.getters.loginState
        }

        Vue.prototype.$setUserDevice = function(token) {
            if (this.$loginCheck) {
                localStorage.setItem('umshe.fcmKey', token)
                this.$store.commit('setDevice', {fcmKey: token})

                let data = new FormData()

                data.append('m', 'member')
                data.append('t', 'member_device')
                data.append('mb_idx', this.$store.getters.getIdx)
                data.append('version', this.$store.getters.getAppVersion)
                data.append('device_type', this.$store.getters.getPlatform)
                data.append('fcm_key', token)

                this.$http({data})
                .then(res => {
                    console.log(res.data)
                }).catch(err => {

                })
            }
        }

        Vue.prototype.$logout = function(flag) {
            this.$showAside(false)

            if (flag === true) {
                localStorage.setItem('umshe.email', '')
                localStorage.setItem('umshe.name', '')
                localStorage.setItem('umshe.type', '')
                localStorage.setItem('umshe.idx', '')
                localStorage.setItem('umshe.photo', '')

                this.$store.commit('clearSession')
                this.$router.replace('/login')
            } else {
                modal.confirm({
                    title: '로그아웃 확인',
                    message: '로그아웃 하시겠습니까?',
                    okay: () => {
                        localStorage.setItem('umshe.email', '')
                        localStorage.setItem('umshe.name', '')
                        localStorage.setItem('umshe.type', '')
                        localStorage.setItem('umshe.idx', '')
                        localStorage.setItem('umshe.photo', '')

                        this.$store.commit('clearSession')
                        this.$router.replace('/login')
                    }
                })
            }
        }

        //알림 메시지
        Vue.prototype.$alert = function(opt) {
            var msg = '', title = '포스코이앤씨', btnName = '확인', url = '', callback = null
            //msg, url, title, btnName, callback
            if (typeof opt == 'object') {
                msg = opt.msg

                if (opt.title) {
                    title = opt.title
                }

                if (opt.btnName) {
                    btnName = opt.btnName
                }

                if (typeof opt.callback == 'function') {
                    callback = opt.callback
                }
            } else {
                msg = opt
            }

            if (this.$store.getters.getDeviceReady) {
                navigator.notification.alert(msg, callback, title, btnName)
            } else {
                alert(msg);

                if (typeof callback == "function") {
                    callback.call()
                }
            }

            if (url) {
                this.$router.push(url)
            }

            return false
        }

        Vue.prototype.$confirm = function(opt) {
            let callback = null, title = '포스코이앤씨', buttons = ['확인', '취소'], msg = ''

            if (typeof opt == 'object') {
                msg = opt.msg

                if (opt.title) {
                    title = opt.title
                }

                if (opt.buttons) {
                    buttons = opt.buttons
                }

                if (typeof opt.callback == 'function') {
                    callback = opt.callback
                }
            } else {
                msg = opt
            }

            if (this.$store.getters.getDeviceReady) {
                navigator.notification.confirm(msg, callback, title, buttons)
            } else {
                if (confirm(msg)) {
                    if (typeof callback == "function") {
                        callback.call(1)
                    }
                }
            }

            return false;
        }

        Vue.prototype.$showAside = function(flag) {
            this.$store.commit('setAsideState', flag)
        }

        Vue.prototype.$diaryPhotoPath = function(filePath, thumbnail = false) {
            let file =  ''

            // 파일의 경로라 구 경로 일 경우
            if (filePath.indexOf('/photo') > -1) {
                file = filePath.replace('/file/photo', '/upload/profile')
            } else {
                file = filePath
            }

            if (thumbnail) {
                let tmp = file.split('/')

                return this.$store.state.diaryUrl + '/' + tmp[0] + '/thumb/' + tmp[1]
            } else {
                return this.$store.state.diaryUrl + '/' + file
            }
        }

        Vue.prototype.$notification = function(data) {
            setTimeout(() => {
                switch (data.type) {
                    case 'NEW_JOB':
                        this.$router.push('/job?idx=' + data.idx)
                        break
                    case 'APPLY_JOB':
                        this.$router.push('/job/applyTeacher/' + data.idx)
                        break
                    case 'RSV_JOB':
                        this.$router.push('/job/standby?type=request?idx=' + data.idx)
                        break
                    case 'CONF_TCH':
                        this.$router.push('/job/applyTeacher/' + data.idx)
                        break
                    case 'NEW_DIARY':
                        this.$router.push('/job/diary?idx=' + data.idx)
                        break
                    case 'SCHE_DIARY':
                        this.$router.push('/job/diary')
                        break
                    case 'SCHE_24HOUR_P':
                    case 'SCHE_1HOUR_P':
                        this.$router.push('/job?idx=' + data.idx)
                        break
                    case 'SCHE_24HOUR_T':
                    case 'SCHE_1HOUR_T':
                        this.$router.push('/job/service?idx=' + data.idx)
                        break
                }
            }, 500)
        }

        window.util = () => {}

        window.util.ifEmpty = (str, replace) => {
            if (str === null || str === undefined || str === '') {
                if (replace) {
                    return replace
                } else {
                    return ''
                }
            } else {
                return str
            }
        }

        window.util.isEmpty = str => {
            if (str === null || str === undefined || str === '') {
                return true
            } else {
                return false
            }
        }

        // axios error console log
        window.util.axiosLog = (error, flag) => {
            console.log('error console flag: ', flag)

            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log('response data: ', error.response.data);
                console.log('response status: ', error.response.status);
                console.log('response header: ', error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log('request error: ', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('etc error:', error.message);
            }

            console.log('axios config:', error.config);
        }

        window.util.paymentState = function(state) {
            let rt = {label: '', color: ''}

            switch (state) {
                case 'P':
                    rt.label = '결제완료'
                    rt.color = 'success'
                    break
                case 'N':
                    rt.label = '미결제'
                    rt.color = 'grey'
                    break
                case 'C':
                    rt.label = '전체환불'
                    rt.color = 'error'
                    break
                case 'S':
                    rt.label = '부분환불'
                    rt.color = 'warning'
                    break
                case 'U':
                    rt.label = '미수금'
                    rt.color = 'indigo'
                    break
            }

            return rt
        }

        window.util.fileIcon = function(file) {
            let fileSplit = file.split('.')
            const extName = fileSplit[fileSplit.length - 1].toLowerCase()
            let icon = ''

            switch (extName) {
                case 'jpg': case 'jpeg': case 'gif': case 'png': icon = 'file-image'; break
                case 'xls': case 'xlsx': icon = 'file-excel'; break
                case 'ppt': case 'pptx': icon = 'file-powerpoint'; break
                case 'doc': case 'docx': icon = 'file-word'; break
                case 'pdf': icon = 'file-pdf'; break
                case 'zip': case 'z7': case 'rar': case 'tar': case 'gz': case 'ace': case 'cab': case 'rzip': icon = 'file-archive'; break
                case 'mp4': case 'avi': case 'wmv': case 'mov': icon = 'file-video'; break
                case 'mp3': case 'wav': case 'mid': case 'ogg': case 'wma': case 'au': case 'rm': icon = 'file-audio'; break
                case 'txt': icon = 'file-alt'; break
                case 'html': case 'htm': case 'php': case 'asp': case 'js': case 'css': icon = 'file-code'; break
                default: icon = 'file'
            }

            return 'fas fa-' + icon
        }

        window.util.dateFormat = function(date, delimiter, format) {
            let splitDate = date.split(' ')
            let datePart = splitDate[0].split(delimiter)
            let objDate = new Date(parseInt(datePart[0]), parseInt(datePart[1]) - 1, parseInt(datePart[2]), 1, 1, 1)

            let year = parseInt(objDate.getYear()) - 100
            let month = objDate.getMonth() + 1
            let day = objDate.getDate()
            let dYear = objDate.getFullYear()
            let dMonth = month
            let dDay = day

            if (month.toString().length == 1) dMonth = "0" + month
            if (day.toString().length == 1) dDay = "0" + day

            format = format.replace("Y", dYear)
            format = format.replace("m", dMonth)
            format = format.replace("d", dDay)
            format = format.replace("y", year)
            format = format.replace("n", month)
            format = format.replace("j", day)

            return format
        }
    }
}


// WEBPACK FOOTER //
// ./src/util.js